import React from 'react'
// Components
import i18n from 'i18next'
import PropTypes from 'prop-types'
import {Close} from '../Icons/index.jsx'
import {login} from '../Services/api.jsx'
import {apiErrorToMessage} from '../Services/helpers.jsx'
import {showSnackbar} from '../Services/domBridge.jsx'
import Input from './Input.jsx'
import InputPassword from './InputPassword.jsx'
import Spinner from './Spinner.jsx'
import {getLinkToSalesConditions} from '../helpers/externalRoutes.jsx'

export default class LoginModal extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
    onLogin: PropTypes.func,
    isSigninAndOrder: PropTypes.bool,
    onForgotPasswordClick: PropTypes.func,
  }
  state = {
    usernameEmail: '',
    password: '',
    isFormSubmitted: false,
    isPending: false,
  }

  preventDismiss = (event) => {
    event.stopPropagation()
  }

  updateUsernameEmail = (value) => {
    this.setState({
      usernameEmail: value,
    })
  }

  updatePassword = (password) => {
    const regex = /^[A-Za-z0-9.:,;!$%&()=[\]+\-*_]*$/
    if (regex.test(password)) {
      this.setState({
        password: password,
      })
    }
  }

  onSigning = async (event) => {
    if (event && event.preventDefault) event.preventDefault()
    const {isSigninAndOrder, onLogin} = this.props
    const {usernameEmail, password} = this.state
    const isUsernameEmailValid = usernameEmail.length > 0
    const isPasswordValid = password.length >= 1

    this.setState({
      isFormSubmitted: true,
    })

    const canSubmit =
      isPasswordValid && isUsernameEmailValid && !isSigninAndOrder
    const canSubmitAndOrder =
      isPasswordValid && isUsernameEmailValid && isSigninAndOrder

    if (canSubmit || canSubmitAndOrder) {
      this.setState({
        isPending: true,
      })

      try {
        const userToken = await login(usernameEmail, password)
        this.setState(
          {
            isPending: false,
          },
          () => {
            onLogin(userToken)
          },
        )
      } catch (error) {
        this.setState(
          {
            isPending: false,
          },
          () => {
            showSnackbar(apiErrorToMessage(error), 'error')
          },
        )
      }
    }
  }

  submitOnPressKeyEnter = (event) => {
    if (event.keyCode === 13) {
      event.stopPropagation()
      this.onSigning()
    }
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this.submitOnPressKeyEnter)
  }

  componentWillUnmountMount = () => {
    document.removeEventListener('keydown', this.submitOnPressKeyEnter)
  }

  render = () => {
    const {onDismiss, isSigninAndOrder, onForgotPasswordClick} = this.props
    const {usernameEmail, password, isPending, isFormSubmitted} = this.state
    const isUsernameEmailValid = usernameEmail.length > 0
    const isPasswordValid = password.length >= 1
    const showValidations = isFormSubmitted

    return (
      <div className={'modal modal--small'} onClick={onDismiss}>
        <div
          role="dialog"
          className={'modal__body'}
          aria-labelledby="login-modal-title"
          onClick={this.preventDismiss}
        >
          <form onSubmit={this.onSigning}>
            <div className={'modal__content login'}>
              <Close
                className={'modal__header-close--always-visible'}
                onClick={onDismiss}
              />
              <h4 id="login-modal-title">
                {i18n.t('Components.LoginModal.title')}
              </h4>
              <div className={'modal__tabs'}>
                <a className={'link active'} href={'#'}>
                  {i18n.t('Components.LoginModal.signInAsClientLabel')}
                </a>
                <a
                  className={'link'}
                  href={i18n.t('Components.LoginModal.signInAsTranslatorLink')}
                >
                  {i18n.t('Components.LoginModal.signInAsTranslatorLabel')}
                </a>
                <a
                  className={'link'}
                  href={i18n.t('Components.LoginModal.signInAsPartnerLink')}
                >
                  {i18n.t('Components.LoginModal.signInAsPartnerLabel')}
                </a>
              </div>
              <Input
                id="usernameEmail"
                label={i18n.t('Components.LoginModal.emailLabel')}
                placeholder={i18n.t('Components.LoginModal.emailPlaceholder')}
                value={usernameEmail}
                autoComplete={'email username'}
                onChange={this.updateUsernameEmail}
                isValid={isUsernameEmailValid}
                showValidation={showValidations}
                isMandatory={true}
                invalidMessage={i18n.t(
                  'Components.LoginModal.emailInvalidMessage',
                )}
                maxLength={180}
              />
              <InputPassword
                id="password"
                label={i18n.t('Components.LoginModal.passwordLabel')}
                placeholder={i18n.t(
                  'Components.LoginModal.passwordPlaceholder',
                )}
                value={password}
                autoComplete={'password'}
                onChange={this.updatePassword}
                isValid={isPasswordValid}
                showValidation={showValidations}
                isMandatory={true}
                type={'password'}
                maxLength={20}
                invalidMessage={i18n.t(
                  'Components.LoginModal.passwordInvalidMessage',
                )}
              />
              {isSigninAndOrder && (
                <div className={'login__terms'}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: i18n.t(
                        'Components.LoginModal.signinAndSendOrderAcceptConditionsLabel',
                        {salesConditionsURL: getLinkToSalesConditions()},
                      ),
                    }}
                  />
                </div>
              )}
            </div>
            <div className={'modal__footer modal__footer--hide-border'}>
              {isPending ? (
                <div className={'button button--compact'}>
                  <Spinner isWhite={true} />
                </div>
              ) : (
                <button type={'submit'} className={'button--compact'}>
                  {isSigninAndOrder
                    ? i18n.t('Components.LoginModal.signinAndSendOrderButton')
                    : i18n.t('Components.LoginModal.singinButton')}
                </button>
              )}
              <a className={'link'} onClick={onForgotPasswordClick}>
                {i18n.t('Components.LoginModal.forgotPassword')}
              </a>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
